<template>
  <v-app id="app">
    <v-main>
      <legal-dialog :show="legalDialog" @clear="clearLegal"></legal-dialog>
      <app-home v-show="!viewerActive"></app-home>
      <app-viewer-container v-show="viewerActive && legalAccepted"></app-viewer-container>
      <update-alert></update-alert>
    </v-main>
  </v-app>
</template>

<script>
import LegalDialog from "./components/LegalDialog";
import Home from "./views/Home";
import ViewerContainer from "./views/ViewerContainer";
import UpdateAlert from "./components/UpdateAlert";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {
    "legal-dialog": LegalDialog,
    "app-home": Home,
    "app-viewer-container": ViewerContainer,
    "update-alert": UpdateAlert
  },
  data: () => ({
    drawer: false,
    legalDialog: false
  }),
  computed: {
    ...mapState(["viewerActive", "legalAccepted"])
  },
  mounted: function() {
    if ("maxTouchPoints" in navigator) {
      this.setTouchScreenDevice(navigator.maxTouchPoints > 0);
    } else if ("msMaxTouchPoints" in navigator) {
      this.setTouchScreenDevice(navigator.msMaxTouchPoints > 0);
    }
    this.loadUserData();
    setTimeout(() => {
      if (this.legalAccepted === false) {
        this.legalDialog = true;
      }
    }, 1000);
  },
  methods: {
    ...mapMutations(["setTouchScreenDevice", "setViewerActive"]),
    ...mapActions(["loadUserData", "setLegalAccepted"]),
    clearLegal: function(response) {
      this.legalDialog = false;
      if (response === "Accept") {
        this.setLegalAccepted(true);
      } else {
        this.setLegalAccepted(false);
      }
    }
  }
};
</script>

<style>
body {
  height: 100%;
  width: 100%;
  margin: 0px;
}

#app {
  height: 100%;
  width: 100%;
  font-family: Roboto, Noto, "Segoe UI", "Helvetica Neue", "Open Sans";
}
</style>
